var appAXFLOW = appAXFLOW || {};

(function (window, $) {
    'use strict';

    $(function () {
        appAXFLOW.init();
        Cart.init();
        Checkout.init();

        //// Version handler
        //fetch('/version.json')
        //    .then(response => response.json())
        //    .then(jsonResponse => console.log(jsonResponse));
    });

    appAXFLOW = {
        $document: $(document),
        $window: $(window),
        $body: $('body'),
        $main: $('main'),
        $header: $('header'),
        $htmlBody: $('html, body'),
        reInt: /^\d+$/,
        $formDescription: $('.js-form-description'),
        $searchAndCloseBtns: $('.js-search, .js-close-search'),
        $searchMobileToggler: $('.js-search-mobile'),
        $searchInputField: $('.search-input'),
        $searchInputMobileField: $('.search-input-mobile'),
        $chooseLangAndCloseBtns: $('.js-lang, .js-close-lang'),
        $loginFormToggler: $('.js-login-header'),
        $closeLogin: $('.js-close-login'),
        $submitForgotPassword: $('.js-submit-forgot-password'),
        $btnOrangeGhostOpener: $('.js-btn-orange-ghost'),
        $closeAAForm: $('.js-aa-button'),
        $loginFormSubmit: $('.loginForm'),
        $supportSearch: $('.js-support-search'),
        $supportSearchSerial: $('.js-support-search-serial'),
        $supportSearchSubmitBtn: $('.js-search-button'),

        $loginRequestNewAccountToggler: $('.js-request-new-account-toggler'),
        $loginForgotPasswordToggler: $('.js-forgot-password-toggler'),
        $loginLoginToggler: $('.js-login-form-toggler'),
        $loginForgotPasswordCancel: $('.js-forgot-password-cancel'),
        $requestNewAccountSubmit: $('.js-submit-request-new-account'),
        $newAccountSubmit: $('.js-submit-new-account'),
        $forgotPasswordSubmit: $('.formFP'),

        $newLeadSubmit: $('.js-submit-new-lead'),

        $showAllSparePartKitsButton: $('.js-show-all-sparepartkits'),
        $showAllAccessoriesButton: $('.js-show-all-accessories'),
        $showAllSparepartsButton: $('.js-show-all-spareparts'),
        $showAllDocumentsButton: $('.js-show-all-documents'),
        $showAllSearchPageDocuments: $('.js-show-search-documents'),
        $showAllSupportSearch: $('.js-support-search-show-all'),
        $showAllItems: $('.js-product-list .js-show-all-items'),
        $showAllModels: $('.js-product-list .js-show-all-models'),
     
        $multiLangBtn: $('.js-multi-lang'),
        $multiLangCloseBtn: $('.js-close-lang-mobile'),
        $searchPanel: $('.js-search-panel'),
        $langsPanel: $('.js-choose-lang-panel'),
        $langsMobilePanel: $('.js-choose-lang-panel'),
        $searchPage: $('.js-search-page'),

        $serviceButton: $('.js-go-to-service-contact'),

        $navThirdLevel: $('.js-third-level'),

        $searchBtn: $('.js-search'),
        $chooseLangBtn: $('.js-lang'),

        $searchPanelClose: $('.js-close-search'),
        $langsPanelClose: $('.js-close-lang'),

        $formInputs: $('.contact-form-content').find('input, textarea, select').not(':input[type=button], :input[type=submit], :input[type=reset]'),
        $facetsForm: $('.js-form-product-selector'),

        $searchlink: $('.js-facet-filter'),

        $flowchartModal: $('.js-flowchart-modal'),
        $flowchartImg: $('.js-flowchart-image img'),
        $imageMapThumbnail: $('.js-image-map-thumbnail'),
        $imageStaticThumbnail: $('.js-image-static-thumbnail'),

        $itemQuantity: $('#quantityQ'),
        $checkoutItemQuantity: $('#CheckoutView .jsChangeCartItem'),

        $supportPageDropdown: $('.js-search-type-select'),
        $openYoutubeInModalLink: $('.js-open-youtube-in-modal'),
        $customerPrice: $('.js-product-price'),

        $explodedChartOverlayCloseButton: $('.js-overlay .js-close-exploded-promt'),

        $linkMap: $('.js-link-map .js-link'),

        $invoicePayment: $('.jsInvoicePayment'),

        $showLangMessLoggedIn: $('.js-show-logged-lang-mess'),
        $hideLangMessNoAxflowMarket: $('.js-close-no-market-warning'),
        $openNoAxflowMarketOverlay: $('.js-login-header-none-axflow-market'),
        $overlayInHeader: $(".js-overlay-in-header"),

        RangeFilterInUse: 0,
        FlowCapacityFilterInUse: 0,
        PressureFilterInUse: 0,
        PortSizeFilterInUse: 0,

        $searchSparepartByItemNr: $('.js-search-sparepart-submit-button'),



        scrollOn: true,
        expandMenuTimer: 0,
        validateAdded: false,

        init: function () {
            appAXFLOW.readyEvents();
            appAXFLOW.checkForTouch();
            appAXFLOW.checkSelected();
            appAXFLOW.clickEvents();
            appAXFLOW.onScrollEvent();
            appAXFLOW.highlightMenuItemOnScroll();
            appAXFLOW.setResponsiveImages();
            appAXFLOW.initSlickSlider();
            appAXFLOW.initSlickSliderEcom();
            appAXFLOW.addFileTypeClass();
            appAXFLOW.bootstrapHoverTabs();
            appAXFLOW.generateSearchFacets();
            appAXFLOW.initRangeSlider();
            appAXFLOW.initLanguagePopUp();
            appAXFLOW.initModelImageSwapper();
            appAXFLOW.initAvailableDates();
            appAXFLOW.recheckAvailabilityDateCheckout();
            appAXFLOW.initSearchTabs();
            appAXFLOW.initLinkDataLayer();
            appAXFLOW.initCustomerPrice();
        },

        readyEvents: function () {
            appAXFLOW.$document.ready(function () {
                if (appAXFLOW.$body.hasClass('js-global-homepage')) {

                    appAXFLOW.showSplashScreen();
                    if ($('.js-local-site').length) {
                        appAXFLOW.hideSplashScreen();
                        return;
                    }
                    if (localStorage.hideSplash) {
                        appAXFLOW.hideSplashScreen();
                    }
                }



                //appAXFLOW.fixWidthSingOutButton();
                if ($('.js-filters')) {
                    appAXFLOW.setFilter("pageReloadLoad");
                }



                if ($('#js-truncated-element').length) {

                    var truncateEl = $('#js-truncated-element').find($('.js-measuring-element'));
                    var showMoreBtn = $('#js-truncated-element').find($('.js-show-truncated'));
                    var height = $('#js-truncated-element').find($('.js-check-height'));
                    if (height.height() > 434) {
                        truncateEl.addClass('truncate');
                        showMoreBtn.removeClass('hidden');
                    }
                    
                   
                }


            });
             appAXFLOW.$document.ready(function () {


                 $('.js-to-kits').on('click', function (e) {
                     e.preventDefault(); 
                     if ($('#sparepartkits').length > 0) {
                         var targetOffset = $('#sparepartkits').offset().top;
                         var headerOffset = 200;

                         
                         $('html, body').animate({
                             scrollTop: targetOffset - headerOffset
                         }, 1500);
                     }
                 });
                var $elementX = $('.js-quantity-info-box'); // Replace #x with your element's selector
                var additionalClasses = ['.js-quantity-info-icon', '.jsCheckQuantity']; // List of classes

                $(document).on('click', function (event) {
                    var $target = $(event.target);

                    // Combine all selectors into one string
                    var additionalSelector = additionalClasses.join(',');

                    // Check if the click target is not the element itself, its children, or the additional elements
                    if (
                        !$target.closest($elementX).length &&
                        !$target.is($elementX) &&
                        !$target.closest(additionalSelector).length &&
                        !$target.is(additionalSelector)
                    ) {
                        $elementX.removeClass('active');
                        $('.js-quantity-info-icon').removeClass('active');// Hide the element
                    }
                });
            });
        },

        setFilter: function (onPageReload) {
            if (location.search.indexOf("filter") != -1) {
                if (location.search.indexOf("&max=") != -1 || location.search.indexOf("min=") != -1) {
                    appAXFLOW.FlowCapacityFilterInUse = 1;
                    if (onPageReload != "") {
                        $('.js-flow-capacity').addClass("selected");
                    }
                }
                if (location.search.indexOf("pmax=") != -1) {
                    appAXFLOW.PressureFilterInUse = 1;
                    if (onPageReload != "") {
                        $('.js-pressure-category').addClass("selected");
                    }
                }
                if (location.search.indexOf("psize=") != -1) {
                    appAXFLOW.PortSizeFilterInUse = 1;
                    if (onPageReload != "") {
                        $('.js-port-size-category').addClass("selected");
                    }
                }
            }
        },

        checkForTouch: function () {
            var isTouch = 'ontouchstart' in document.documentElement;
            if (isTouch) appAXFLOW.$body.addClass('is-touch');
        },

        clickEvents: function () {

            $(".js-show-truncated").on('click', function (e) {
                e.preventDefault();
                $(this).addClass('hidden');
                $(this).parent().find('.js-measuring-element').removeClass('global-truncated-description');


            });


            $(".js-open-bubble").on('click', function (e) {
                e.preventDefault();
                var bubble = $(this).parent().find('.js-global-bubble');
                $(this).addClass('active').attr('aria-expanded', true);


                if ($(this).hasClass('js-category-page')) {
                    var bubbleHtml = $('#jsSummaryDescription').html();
                    bubble.html(bubbleHtml);
                }
                bubble.removeClass('hidden');
                bubble.prop('hidden', false);
            });

            
            $(".js-mobile-menu-toggel").on('click', function (e) {
                e.preventDefault();
                $(this).siblings(".caption").toggleClass("active");
                if ($(this).parent().hasClass("active-not-selected")) {
                    $(this).parent().removeClass("active-not-selected selected");
                }
            });
            $(".js-show-third-level").on('click', function (e) {
                e.preventDefault();
              
                $(this).toggleClass("active");
                if ($(this).attr("aria-expanded") == "true") {
                    $(this).attr("aria-expanded", "false");
                }
                else {
                    $(this).attr("aria-expanded", "true");
                }

                $(this).parent().toggleClass("active").find(".js-dot-com-third-level").toggleClass("active");
            });
            $(".jsCheckQuantity").on('input', function (e) {
                $(this).parent().find(".js-quantity-info-box").removeClass("active");
                $(this).parent().parent().find(".js-quantity-info-icon").removeClass("active");
                if ($(this).val() < $(this).data("quantity")) { 
                    $(this).parent().find(".js-quantity-info-box").addClass("active");
                    $(this).parent().parent().find(".js-quantity-info-icon").addClass("active");
                }
            });

            $(".js-quantity-info-icon").on('click', function (e) {
                e.preventDefault();

                
                $(this).toggleClass("active");
                $(this).parent().find(".js-quantity-info-box").toggleClass("active");
            });

            $(".js-cookie-link").on('click', function (e) {
                e.preventDefault();
            });


            $(".jsAddSparePart, .jsAddToCart ").on('click', function (e) {

                if (typeof track_load === "function") {

                    var url = $(this).data("url");
                    var productName = $(this).data("productname");
                    var itemnumber = $(this).data("itemnumber");

                    if (url === "currentpage" || $(this).hasClass('js-exploaded-quote-button')) {
                        url = window.location.href;
                    }

                    var trackUrl = url + "?t=qr&itemnr="+ itemnumber + "&name=" + productName ;

                    if ($(this).hasClass('js-exploaded-quote-button')) {
                        trackUrl = url + "?t=qr&itemnumber=exploaded_view";
                    }

                    var trackTitle = "Quote request: " + productName + " | " + itemnumber;

                    if ($(this).data("container") === "QuoteListMiniCart") {
                        track_load(trackUrl, trackTitle);
                    }
                }
            });

            $("#exploadedViewSelect").on('change', function (e) {
                var selectedValue = this.value;
                var spareParts = $('.js-exploaded-view-sparpartlist .js-sparepart');
                var hit = 0;
                if (selectedValue.toLowerCase() != "default") {
                    spareParts.addClass('hidden');
                    spareParts.each(function (index) {

                        if (selectedValue.toLowerCase() === ($(this).attr('data-itemnr').toLowerCase())) {
                            $(this).removeClass('hidden');
                            hit++;
                        }

                    });
                    $('#nrOfSparePartsExploadViewList').text(hit);
                }
            
            });
            $(".js-product-list").on('click','.js-series-link' ,function (e) {
                e.preventDefault();
               
                if (location.search.indexOf("filter") != -1) {
                    window.location.href = $(this).attr("href") + location.search;
                } else {
                    window.location.href = $(this).attr("href");
                }
            });

            $(".js-show-disclaimer").on('click', function (e) {
                e.preventDefault();
                $(".js-hidden-disclaimer").toggleClass("hidden");
                $(this).toggleClass("active");
            });
            $(".js-calculator-navigation-button").on('click', function (e) {
               
                window.location.href = $("#calculator-navigation-selector").find(":selected").val();
            });
            appAXFLOW.$imageStaticThumbnail.on('click', function (e) {
                e.preventDefault();
                appAXFLOW.$imageStaticThumbnail.removeClass("active");
                $(this).addClass("active");
                $('.js-static-exploaded-views-image img').attr('src', $(this).find($('img')).attr('src'));
            });


            
            $('#clearItemNrSearch').on('click', function (e) {
                e.preventDefault();
                $('#searchSparePartItemNr').val('');
                $('.js-spareparts .js-full-sparpartlist .js-sparepart').removeClass('hidden');
                $('#noSearchResult').addClass('hidden');
                $(this).addClass('hidden');
                $('#nrOfSpareParts').text($('#nrOfSpareParts').attr('data-defaultamount'));
            });

            $('#searchSparePartItemNr').on('keyup', function (e) {
                appAXFLOW.$searchSparepartByItemNr.click();
            }); 

            appAXFLOW.$searchSparepartByItemNr.on('click', function (e) {
                var searchText = $('#searchSparePartItemNr').val().trim().toLowerCase();
                var hit = 0;
                if (searchText != '') {
                    var spareParts = $('.js-spareparts .js-full-sparpartlist .js-sparepart');
                    var noSeartchResult = $('#noSearchResult');
                    var showAllButton = $('.js-spareparts .js-full-sparpartlist .js-show-all-spareparts');
                    showAllButton.addClass('hidden');
                    noSeartchResult.addClass('hidden');
                    spareParts.addClass('hidden');
                    $('#clearItemNrSearch').removeClass('hidden');
                    spareParts.each(function (index) {
                        if ($(this).data('itemnr').toLowerCase().indexOf(searchText) > -1 ||
                            $(this).data('title').toLowerCase().indexOf(searchText) > -1) {
                            $(this).removeClass('hidden');
                            hit++;
                        }
                    });
                    $('#nrOfSpareParts').text(hit);
                    if (hit == 0) {
                        noSeartchResult.removeClass('hidden');
                    }
                }
                else {
                    $('#clearItemNrSearch').click();
                }
            });

            appAXFLOW.$openNoAxflowMarketOverlay.on('click', function (e) {
                appAXFLOW.$overlayInHeader.removeClass("hidden");
            });
            appAXFLOW.$invoicePayment.on('click', function (e) {
                $('.js-payment-area').prepend('<div class="js-invoice-spinner invoice-spinner"><img src="/gear-spinner-darker.svg" alt="loading-icon" class="expected-delivery-img"></div>');
            });

            

            appAXFLOW.$document.on('mouseup', function (e) {
                if ($(e.target).closest('.js-language-selector-helper-logged-in').length === 0)
                {
                    $('.js-language-selector-helper-logged-in').removeClass("visible");
                }
                if (!$(e.target).closest('.js-sparepart-list-info-link, .js-info-text-container').length) {
                    $('.js-sparepart-list-info-link.active, .js-info-text-container.active').removeClass('active');
                }
                if (!$(e.target).closest('.js-global-bubble').length) {
                    $('.js-open-bubble.active').removeClass('active').attr('aria-expanded',false);
                    $('.js-global-bubble').addClass('hidden').prop('hidden',true);

                    $('.js-global-bubble-category-page').html(''); 
                }

            });
            appAXFLOW.$showLangMessLoggedIn.on('click', function (e) {
                e.preventDefault();
                var el = $(this).siblings(".js-language-selector-helper-logged-in");
                el.addClass("visible");
                
            });

            appAXFLOW.$hideLangMessNoAxflowMarket.on('click', function (e) {
                e.preventDefault();
                if ($(this).hasClass("js-scoped")) {
                    $(this).closest(".js-language-selector-helper").addClass("hidden");
                }
                $(".js-show-none-axflow-market.js-language-selector-helper").addClass("hidden");
            });

            appAXFLOW.$linkMap.on('click', function (e) {
                e.preventDefault();
                var parent = $(this).parent();
                if ($(this).hasClass("js-area")) {
                    parent = $(this).parent().parent();
                }

            
              
                if (parent.hasClass("active")) {
                    parent.removeClass("active");
                    $(this).attr("aria-expanded", "false");
                   

                } else {
                    parent.addClass("active");
                    $(this).attr("aria-expanded", "true");
                
                }
            });

            appAXFLOW.$explodedChartOverlayCloseButton.on('click', function (e) {
                e.preventDefault();
                $(this).parent().parent('.js-overlay').addClass("hidden");
               
            });


            appAXFLOW.$openYoutubeInModalLink.on('click', function (e) {
                e.preventDefault();  
                var iframecode = "<div class='youtube-modal'><div class='youtube-wrapper'><iframe width='800' height='450' src='" + $(this).data("youtubecode") + "'></iframe><span class='js-youtube-modal-close youtube-modal-close'>×</span></div></div>";
                $(".downloads-section").prepend(iframecode);
                $('.js-youtube-modal-close').on('click', function (e) {
                    $('.youtube-modal').remove();
                });

            });

           
            // mobile navigation button click
            $('.js-burger-nav').on('click', function (e) {
                e.preventDefault();
                if ((window.matchMedia('(min-width: 992px)').matches) && !$('body').hasClass('is-touch')) {
                    //
                    //console.log("Less than 992px");
                } else {
                    if (appAXFLOW.$langsPanel.hasClass('on')) {
                        appAXFLOW.$chooseLangBtn.trigger('click');
                    }

                    if (appAXFLOW.$searchPanel.hasClass('on')) {
                        appAXFLOW.$searchBtn.trigger('click');
                    }

                    $('nav.main-nav--mobile').toggleClass('in');
                }
            });
            $('.js-burger-active').on('click', function (e) {
                e.preventDefault();
                $(this).toggleClass('active');
            });

            $(".js-open-modal").click(function (e) {
                e.preventDefault();

                if (!$(".js-modal-container").hasClass("js-slider-modal")) {
                    $(".js-modal-container").addClass("js-slider-modal");

                    $('.js-open-modal').each(function () {
                        var data = $(this).attr("data");
                        var src = $(this).attr("src");

                        $(this).attr('src', data);
                        $(this).attr('data', src);
                    });
                }
            });

            $(".js-open-single-modal").click(function (e) {
                e.preventDefault();
                $('.js-slider-ecom').slick('refresh');
                $('.js-slider-nav').slick('refresh');
                if (!$(".js-single-modal-container").hasClass("js-single-modal")) {
                    $(".js-single-modal-container").addClass("js-single-modal");

                    $('.js-open-single-modal').each(function () {
                        var data = $(this).attr("data");
                        var src = $(this).attr("src");

                        $(this).attr('src', data);
                        $(this).attr('data', src);
                    });

                    window.dispatchEvent(new Event('resize'));
                    $(window).trigger('resize');
                }
            });

            //handler to close modal when click outside
            $('body').click(function (event) {
                if ($(".js-single-modal-container").hasClass("js-single-modal")) {
                    if (event.target.matches(".js-single-modal-close") ||
                        !event.target.closest(".slick-slider")) {
                        $(".js-single-modal-close").click();
                    }
                }
                if ($(".login-modal").hasClass("showing")) {
                    //console.log(event.target);
                    if (event.target.matches(".close-button") ||
                        $(event.target).is('.login-modal')) {

                        $(".login-modal").toggleClass("showing");
                        $(".login-mobile-modal").toggleClass("showing");
                        appAXFLOW.resetLoginModal();
                    }

                }
            });

            $('body').keydown(function (event) {
                if (event.keyCode == 27) {
                    if ($(".js-single-modal-container").hasClass("js-single-modal")) {
                        $(".js-single-modal-close").click();
                    }
                }
            });

            //on close button modal slider
            $(".js-single-modal-close").click(function (e) {
                e.preventDefault();

                $(".js-single-modal-container").removeClass("js-single-modal");

                $('.js-single-open-modal').each(function () {
                    var data = $(this).attr("data");
                    var src = $(this).attr("src");

                    $(this).attr('src', data);
                    $(this).attr('data', src);
                });
                //$('.js-slider-ecom').slick('unslick');
                //$('.js-slider-nav').slick('unslick');

                //if ($('.js-slider-ecom').hasClass('slick-initialized')) {
                //    $('.js-slider-ecom').slick('destroy');
                //}   
                //if ($('.js-slider-nav').hasClass('slick-initialized')) {
                //    $('.js-slider-nav').slick('destroy');
                //}      

                setTimeout(function () {

                    $('.js-slider-ecom').slick('refresh');
                    $('.js-slider-nav').slick('refresh');
                    appAXFLOW.clickEvents();
                },
                    150);
            });



            $(".js-modal-close").click(function (e) {
                e.preventDefault();

                $(".js-modal-container").removeClass("js-slider-modal");

                $('.js-open-modal').each(function () {
                    var data = $(this).attr("data");
                    var src = $(this).attr("src");

                    $(this).attr('src', data);
                    $(this).attr('data', src);
                });
                window.dispatchEvent(new Event('resize'));
            });

            var marginRightModal = $(".product-slider").css("margin-right");
            $(".js-modal-close").css("margin-right", marginRightModal);
            $(".js-single-modal-close").css("margin-right", marginRightModal);

            $(window).resize(function () {
                marginRightModal = $(".product-slider").css("margin-right");
                $(".js-modal-close").css("margin-right", marginRightModal);
                $(".js-single-modal-close").css("margin-right", marginRightModal);
            });

            $(".modal-close").click(function (e) {
                e.preventDefault();

                $('.block-modal').removeClass("modal-active");
            });

            $(".select-expand").click(function (e) {
                e.preventDefault();

                var parent = $(this).parent().parent();

                parent.siblings().removeClass("active");
                parent.toggleClass("active");
            });

            // Set hidden field after form type is selected 
            $('.contact-form-content').find('select[data-select-id="FormType"]').on('change',
                function () {
                    $("[name='__FormId']").val(this.value);
                    $("[name='__FormId']").attr('data-updated', 'true');
                });

            // Tacking form interaction and pushing to GTM
            if (typeof $$epiforms !== 'undefined') {

                var formInteractionTriggered = false;  // Flag to track if form interaction has already been pushed
                $$epiforms(document).ready(function gtmPush() {

                    $$epiforms(".EPiServerForms").on("formsSubmitted formsNavigationNextStep",
                        function (event) {

                            // Find Form Element Type
                            var inputHiddenFiled;
                            var selectFiled;
                            var formId = "other";
                           
                            $$epiforms(".EPiServerForms").each(function () {
                                inputHiddenFiled = $('input[data-select-id="FormType"]');
                                selectFiled = $(this).find('select').attr('data-select-id');
                            });
                            if ((typeof inputHiddenFiled !== 'undefined') && (typeof inputHiddenFiled.val() !== 'undefined')) {
                                formId = inputHiddenFiled.val();
                            } else {
                                if (typeof selectFiled !== 'undefined') {
                                    var selectedValue = $("[name='__FormId']").val();
                                    if (selectedValue !== 'undefined')
                                        formId = selectedValue;
                                }
                            }

                            var eventType;
                            if (event.isFinalizedSubmission) {
                                eventType = 'formSubmissionSuccess';

                                $([document.documentElement, document.body]).animate({
                                    scrollTop: $(".contact-form-content").offset().top - 55
                                }, 500);
                            }
                            if (event.type === "formsNavigationNextStep") {
                                if ($("[name='__FormCurrentStepIndex']").val() === "0")
                                    if (!formInteractionTriggered) {
                                        eventType = 'formInteraction';
                                        formInteractionTriggered = true;
                                    }

                            }
                            if (typeof eventType !== 'undefined') {
                                window.dataLayer = window.dataLayer || [];
                                window.dataLayer.push({
                                    'event': eventType,
                                    'formType': formId // fetched from type sent to CRM eg. quick contact, product inquiry, service inquiry 
                                });
                            }
                        });


                        //
                    //Track only the first interaction with simple form form input
                    var inputHiddenFiled = $('input[data-select-id="FormType"]');
                    if (inputHiddenFiled.length > 0 && typeof inputHiddenFiled.val() !== 'undefined') {
                        $$epiforms(".EPiServerForms input, .EPiServerForms select, .EPiServerForms textarea").one("focus change", function () {
                            if (!formInteractionTriggered) { // Check if the event has already been triggered
                                var formId = "other"; // Default value in case formId cannot be determined
                                    formId = inputHiddenFiled.val();
                                    window.dataLayer = window.dataLayer || [];
                                    window.dataLayer.push({
                                        'event': 'formInteraction',
                                        'formType': formId// Using the formType identifier
                                    });
                                    formInteractionTriggered = true;
                            }
                        });
                    }
                });

            }
            else {
                if ($('.contact-form-content form').length) {
                    $('.contact-form-content form').attr('action', '#contact');
                    $('.contact-form-content form input, .contact-form-content form textarea').placeholder();
                    $('.contact-form-content form label.form-choice-element input').on('change', function () {
                        if (this.checked) {
                            $(this).parent().addClass("checked");
                        }
                        else {
                            $(this).parent().removeClass("checked");
                        }
                    });
                    $(".contact-form-content form label.form-choice-element input").each(function () {
                        if (this.checked) {
                            $(this).parent().addClass("checked");
                        }
                        else {
                            $(this).parent().removeClass("checked");
                        }
                    });
                }
            }

            $('.js-scroll-next').on('click', function (e) {
                e.preventDefault();

                var targetTopPosition = $(".hero").height();
                var headerHeight = $("body > header .logo-plus").height();
                var correctHeight = targetTopPosition + headerHeight;

                appAXFLOW.$htmlBody.animate({
                    scrollTop: correctHeight
                }, 500, function () {

                });
            });
            var beforeposition = 0;
            $('.js-scroll-contact').on('click', function (e) {
                e.preventDefault();

                //light up the back button and hide the other
                $('.floating-back').css("display", "block");
                $('.floating-contact').css("display", "none");

                beforeposition = window.pageYOffset;

                if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                    var topMenu = $('nav.main-nav');
                    var secondaryMenu = $('nav.secondary-menu');
                    var target = $(this.hash);
                    var targetTopPosition = target.offset().top - topMenu.innerHeight();
                    if (secondaryMenu.exists()) {
                        targetTopPosition = targetTopPosition - secondaryMenu.innerHeight();
                    }
                    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                    
                    if (target.length) {
                        appAXFLOW.$htmlBody.animate({
                            scrollTop: targetTopPosition
                        }, 500, function () {

                        });

                        return false;
                    }
                }
            });
            $('.js-scroll-categorypage').on('click', function (e) {
                e.preventDefault();
                var topMenu = $('nav.main-nav');
                var secondaryMenu = $('nav.secondary-menu');
                var target = $(this.hash);
                var targetTopPosition = target.offset().top - topMenu.innerHeight();
                if (secondaryMenu.exists()) {
                    targetTopPosition = targetTopPosition - secondaryMenu.innerHeight();
                }
                appAXFLOW.$htmlBody.animate({
                    scrollTop: targetTopPosition
                }, 500, function () {

                });
            });


            $('.js-scroll-back').on('click', function (e) {

                $('.floating-back').css("display", "none");
                $('.floating-contact').css("display", "block");

                appAXFLOW.$htmlBody.animate({
                    scrollTop: beforeposition
                }, 500, function () {
                });
            });

            appAXFLOW.$itemQuantity.on('change', function (e) {
                var qty = appAXFLOW.$itemQuantity.val();
                appAXFLOW.recheckAvailableDates(qty);
            });

            appAXFLOW.$checkoutItemQuantity.on('change', function (e) {
                //console.log("checkout date trigger");
                //appAXFLOW.recheckAvailabilityDateCheckout();
            });
            appAXFLOW.$supportPageDropdown.on('change', function (e) {
                 $('.js-text-input-search').prop("disabled", false); // Element(s) are now enabled.
            });
            // header support link (search) click event
            appAXFLOW.$searchAndCloseBtns.on('click', function (e) {
                e.preventDefault();
                if ($('.search-input').val()) {
                    $('#submit-search').closest('form').submit();
                } else {
                    $('.inline-search').toggleClass('showing');
                    $('.search').toggleClass('active');
                    $('.search-input').focus();
                }
            });
            // mobile search toggler
            appAXFLOW.$searchMobileToggler.on('click',
                function (e) {
                    e.preventDefault();
                    if ($('.search-input-mobile').val()) {
                        $('.js-submit-search-mobile').closest('form').submit();
                    } else {
                        $('.inline-search').toggleClass('showing');
                        $('.js-search-mobile').toggleClass('remove-icon');
                    }
                });
            // desktop search hider
            appAXFLOW.$searchInputField.blur(
                function () {
                    //desktop search unfocus

                    if (!$('.search-input').val()) {
                        $('.inline-search').removeClass('showing');
                        $('.search').removeClass('active');
                    }
                });
            // mobile hider
            appAXFLOW.$searchInputMobileField.blur(
                function () {
                    if (!$('.search-input-mobile').val()) {
                        $('.inline-search').removeClass('showing');
                        $('.search').removeClass('active');
                        $('.js-search-mobile').removeClass('remove-icon');
                    }
                });

            
            appAXFLOW.$closeLogin.on('click', function (e) {
                e.preventDefault();
                appAXFLOW.resetLoginModal();
                $(".login-modal").toggleClass("showing");
                $(".login-mobile-modal").toggleClass("showing");
            });

            // header support link (login) click event
            appAXFLOW.$loginFormToggler.on('click', function (e) {
                e.preventDefault();

                if ($("body").hasClass("non-axflow-country-visitor")) {
                    appAXFLOW.$overlayInHeader.removeClass("hidden");
                }
                else {

                    if (!$(this).hasClass("True")) {
                        appAXFLOW.resetLoginModal();
                        $(".login-modal").toggleClass("showing");
                        $(".login-mobile-modal").toggleClass("showing");
                  
                    }
                    // scroll to top
                    appAXFLOW.$htmlBody.animate({
                        scrollTop: 0
                    }, 500, function () {
                        appAXFLOW.scrollOn = true;
                    });
                    /*else {
                        fetch("/waclogout", {
                            method: "GET"
                        })
                            .then(function (response) {
                                return response.json();
                            })
                            .then(function (result) {
                                if (result.Success) {
                                    window.location.reload();
                                }
                            })
                            .catch(function (error) {
                                console.error("Error:", error);
                            });
                    }*/
                }
            });

            $('.lOut').on('click', function (e) {
                e.preventDefault();
                fetch("/waclogout", {
                    method: "GET"
                })
                    .then(function (response) {
                        return response.json();
                    })
                    .then(function (result) {
                        if (result.Success) {
                            if (result.URL)
                                window.location.href = result.URL;
                            else
                                window.location.reload();
                        }
                    })
                    .catch(function (error) {
                        console.error("Error:", error);
                    });
                return false;
            });

            appAXFLOW.$btnOrangeGhostOpener.on('click', function (e) {
                e.preventDefault();
                if (!appAXFLOW.$loginFormToggler.hasClass("True")) {
                    $(".login-modal").toggleClass("showing");
                    $(".login-mobile-modal").toggleClass("showing");
                }
            });

            appAXFLOW.$closeAAForm.on('click', function (e) {
                e.preventDefault();
                $(".aa-modal").toggleClass("showing");
            });

            appAXFLOW.$forgotPasswordSubmit.on('submit',
                function (e) {
                    e.stopPropagation();
                    e.cancelBubble = false;
                    e.preventDefault();
                    e.returnValue = false;
                    var formName = "";
                    if ($(this).hasClass("mobileForm")) {
                        formName = "forgotPasswordMobil";

                    } else {
                        formName = "forgotPassword";
                    }
                    var obj = document.getElementById(formName);
                    var formsData = new FormData(obj);
                   
                    fetch("/wacfp", {
                        method: "POST",
                        body: formsData
                    })
                        .then(function (response) {
                            return response.json();
                        })
                        .then(function (result) {
                            if (result.Error) {
                                console.log("error");
                                $(".formFP .info").text("");
                                $(".formFP .error").text(result.Error);
                            }
                            else {
                                console.log("success");
                                $(".formFP .info").text(result.Success);
                                $(".formFP .error").text("");
                                $(".forgot-password .js-hide-on-end-page").addClass("hidden");
                                $(".formFP .js-close-login").removeClass("hidden"); 
                            }
                        })
                        .catch(function (error) {
                            console.error("Error:", error);
                        });
                    return false;
                });
            appAXFLOW.$supportSearch.on('submit', function (e) {    
                e.stopPropagation();
                e.cancelBubble = false;
                e.preventDefault();
                e.returnValue = false;
                $(".js-support-search-show-all").addClass("hidden");
                $(".js-no-hits").addClass("hidden");
                $(".js-search-result").html('<div class="js-show-spinner"><img alt="loading-icon" src="/gear-spinner-darker.svg"></div>');
                var input = $(this).find('input');
                //var type = "pd";
                var query = input.val();
                var companyId = $(this).data('companyid');
                var currentLang = $(this).data('currentlanguage');

                //if (input.hasClass('js-text-input-search-serial')){
                //    type = 'sn';
                //}
                var url = '/Search/ProductSupport?q=' + query + '&c=' + companyId + '&l=' + currentLang;

                $.ajax({
                            type: 'GET',
                            //data: {
                            //    contentGuid: contentGuid,
                            //    languageCode: languageCode,
                            //    nextPage: nextPage
                            //},
                            //url: "/Search/ProductSupport?manufacturer=pedrollo&query=ST4&companyId=025&language=en",
                            url: url,
                            cache: false,
                            dataType: 'html',
                               success: function (data) {
                                if (data != null && data.length > 0) {
                                    //$this.replaceWith(data);
                                    $(".js-search-result").html(data);
                                    $('.js-go-to-contact').on('click', function (e) {
                                        e.preventDefault();
                                        $([document.documentElement, document.body]).animate({
                                            scrollTop: $(".contact-form-content").offset().top
                                        }, 2000);
                                        $(".contact-form-content option[value='ServiceInquiry']").attr("selected", "selected");
                                    });
                                    var count = $(".js-search-result .search-hit").length;
                                    if (count > 4) {
                                        $(".js-support-search-show-all").removeClass("hidden");
                                    }
                                    if (count == 0) {
                                        $(".js-no-hits").removeClass("hidden");
                                    }

                                }
                            },
                            error: function () {
                                console.error('More items could not be loaded.');
                            }
                        });
                } 

            );
            appAXFLOW.$showAllSupportSearch.on('click',
                function (e) {
                    $(".js-search-result .search-hit").show();
                    $(".js-support-search-show-all").addClass("hidden");

            });

            appAXFLOW.$loginFormSubmit.on('submit',
                function (e) {
                    e.stopPropagation();
                    e.cancelBubble = false;
                    e.preventDefault();
                    e.returnValue = false;
                    var searchButton = $(this).find(".sign-in");
                    var spinner = $(this).find(".js-show-spinner");
                    searchButton.addClass('active-spinner');
                    spinner.addClass('show-spinner');
                    fetch("/webaccountlogin", {
                        method: "POST",
                        body: new FormData($(this).closest(".loginForm")[0])
                    })
                        .then(function (response) {
                            return response.json();
                        })
                        .then(function (result) {
                            if (result.Error) {
                                $(".loginForm .error").text(result.Error);
                                $(".loginForm .info").text("");
                                $("#spanWelcome").text("");
                                spinner.removeClass('show-spinner');
                                searchButton.removeClass('active-spinner');
                            }
                            else {
                                $(".loginForm .error").text("");
                                $(".loginForm .info").text(result.Congrats);
                                $("#spanWelcome").text(result.Welcome);
                                spinner.removeClass('show-spinner');
                                searchButton.removeClass('active-spinner');
                                if (result.MarketLanguage != "") {
                                    setTimeout(function () { window.location.pathname = "/" + result.MarketLanguage; }, 1100);
                                }
                                else {
                                    setTimeout(function () { window.location.reload(); }, 1100);
                                }
                            }
                        })
                        .catch(function (error) {
                            console.error("Error:", error);
                        });
                    return false;
                });

            appAXFLOW.$loginForgotPasswordToggler.on('click',
                function (e) {
                    e.preventDefault();
                    $(".forgot-password").removeClass("hidden");
                    $(".request-new-account").addClass("hidden");
                    $(".login-form").addClass("hidden");
                    $(".jsFpDiv").addClass("hidden");
                    $(".formApply .error").text("");
                });
            appAXFLOW.$loginForgotPasswordCancel.on('click', function (e) {
                e.preventDefault();
                appAXFLOW.resetLoginModal();

            });

            appAXFLOW.$loginLoginToggler.on('click', function (e) {
                e.preventDefault();
                $(".login-form").removeClass("hidden");
                $(".forgot-password").addClass("hidden");
                $(".request-new-account").addClass("hidden");
                $(".jsFpDiv").addClass("hidden");
                $(".formApply .error").text("");
            });
            appAXFLOW.$loginRequestNewAccountToggler.on('click',
                function (e) {
                    e.preventDefault();
                    $(".login-form").addClass("hidden");
                    $(".request-new-account").removeClass("hidden");
                    $(".forgot-password").addClass("hidden");
                    $(".jsFpDiv").addClass("hidden");
                    $(".formApply .error").text("");
            });
            appAXFLOW.$requestNewAccountSubmit.on('click',
                function (e) {
                    e.stopPropagation();
                    e.cancelBubble = false;
                    e.preventDefault();
                    e.returnValue = false;
                    $('.formApply .js-show-spinner').addClass("show-spinner");
                    $('.formApply .js-submit-request-new-account').css("color", "#ED6B1D");
                    $(".formApply .error").text("");
                    fetch("/webnewacc", {
                        method: "POST",
                        body: new FormData($(this).closest("form")[0])
                    })
                        .then(function (response) {
                            return response.json();
                        })
                        .then(function (result) {
                            $('.formApply .js-show-spinner').removeClass("show-spinner");
                            $('.formApply .js-submit-request-new-account').css("color", "#fefefe");
                            if (result.Message) {
                                $(".formApply").addClass("hidden");
                                $(".js-new-user-preamble").addClass("hidden");
                                $(".applyThanks p").text(result.Message);
                                $(".applyThanks").removeClass("hidden");
                            }
                            else if (result.Error) {
                                $(".formApply .error").text(result.Error);
                                if (result.FPLink) {
                                    $(".formApply .jsFpDiv").removeClass("hidden");
                                }
                            }
                            else if (result.NotExistsInCRM) {
                                $(".js-success-unknown-user").removeClass("hidden");
                                $(".js-submit-request-new-account").addClass("hidden");
                                $(".formApply .error").text("");
                            }
                            else {
                                console.log("Exists");
                                $(".formApply").addClass("hidden");
                                $(".js-new-user-preamble").addClass("hidden");
                                $(".applyThanks").removeClass("hidden");
                            }
                        })
                        .catch(function (error) {
                            $("[name='formApply'] .error").text("Error:" + error);
                            $('.formApply .js-show-spinner').removeClass("show-spinner");
                            $('.formApply .js-submit-request-new-account').css("color", "#fefefe");
                        });
                    return false;
                });

            appAXFLOW.$newAccountSubmit.on('click',
                function (e) {
                    e.stopPropagation();
                    e.cancelBubble = false;
                    e.preventDefault();
                    e.returnValue = false;
                    $('.formApply .js-show-spinner').addClass("show-spinner");
                    $('.formApply .js-submit-new-account').css("color", "#ED6B1D");
                    $(".formApply .error").text("");
                    $(".formApply .jr").remove();
                    fetch("/webnewaccunknown", {
                        method: "POST",
                        body: new FormData($(this).closest("form")[0])
                    })
                        .then(function (response) {
                            return response.json();
                        })
                        .then(function (result) {
                            $('.formApply .js-show-spinner').removeClass("show-spinner");
                            $('.formApply .js-submit-new-account').css("color", "#fefefe");
                            if (result.Error) {
                                if (result.Element) {
                                    $(".formApply [name='" + result.Element + "']").after("<span class='error jr'>" + result.Error + "</span>");
                                }
                                else {
                                    $(".formApply .error").text(result.Error);
                                }
                            }
                            else {
                                $(".formApply").addClass("hidden");
                                $(".applyThanks").removeClass("hidden");
                                $('.js-new-user-preamble').addClass('hidden');
                            }
                        })
                        .catch(function (error) {
                            $("[name='formApply'] .error").text("Error:" + error);
                            $('.formApply .js-show-spinner').removeClass("show-spinner");
                            $('.formApply .js-submit-new-account').css("color", "#fefefe");
                        });
                    return false;
                });

            //appAXFLOW.$newLeadSubmit.on('click',
            //    function (e) {
            //        e.stopPropagation();
            //        e.cancelBubble = false;
            //        e.preventDefault();
            //        e.returnValue = false;
            //        $('.formNewLead .js-show-spinner').addClass("show-spinner");
            //        $('.formNewLead .js-submit-new-lead').css("color", "#ED6B1D");
            //        $(".formNewLead .error").text("");
            //        $(".formNewLead .jr").remove();
            //        fetch("/axb/postlead", {
            //            method: "POST",
            //            body: new FormData($(this).closest("form")[0])
            //        })
            //            .then(function (response) {
            //                return response.json();
            //            })
            //            .then(function (result) {
            //                $('.formNewLead .js-show-spinner').removeClass("show-spinner");
            //                $('.formNewLead .js-submit-new-lead').css("color", "#fefefe");
            //                if (result.Error) {
            //                    if (result.Element) {
            //                        $(".formNewLead [name='" + result.Element + "']").after("<span class='error jr'>" + result.Error + "</span>");
            //                    }
            //                    else {
            //                        $(".formNewLead .error").text(result.Error);
            //                    }
            //                }
            //                else {
            //                    $(".formNewLead").addClass("hidden");
            //                    $(".applyThanks").removeClass("hidden");
            //                    /*$('.js-new-user-preamble').addClass('hidden');*/
            //                }
            //            })
            //            .catch(function (error) {
            //                $("[name='formNewLead'] .error").text("Error:" + error);
            //                $('.formNewLead .js-show-spinner').removeClass("show-spinner");
            //                $('.formNewLead .js-submit-new-lead').css("color", "#fefefe");
            //            });
            //        return false;
            //    });
            // header support link (country selector) click event
            appAXFLOW.$chooseLangAndCloseBtns.on('click', function (e) {
                e.preventDefault();
                if (appAXFLOW.$searchPanel.hasClass('on')) {
                    appAXFLOW.$searchBtn.trigger('click');
                }
                $('.main-nav--mobile').removeClass('in');
                $('.js-burger-active').removeClass('active');
                appAXFLOW.toggleLanguagePanel();
                appAXFLOW.scrollOn = false;
                // scroll to top
                appAXFLOW.$htmlBody.animate({
                    scrollTop: 0
                }, 500, function () {
                    appAXFLOW.scrollOn = true;
                });
            });

            //toggle multi language selector
            appAXFLOW.$multiLangBtn.on("click",
                function (e) {
                    e.preventDefault();
                   
                    $(".language-switcher-container").toggleClass("hidden");
                    $(".language-mobile-switcher-container").toggleClass("hidden");
             
                    $(".js-choose-lang-panel-mobile").toggleClass("on");
                    $(".js-choose-lang-panel-mobile").toggleClass("in");
                    if (!$(".js-choose-lang-panel-mobile").is(':hidden')) {
                        appAXFLOW.scrollOn = false;
                        // scroll to top
                        appAXFLOW.$htmlBody.animate({
                            scrollTop: 0
                        }, 500, function () {
                            appAXFLOW.scrollOn = true;
                        });
                    }
                   
                });
            appAXFLOW.$multiLangCloseBtn.on("click",
                function (e) {
                    e.preventDefault();

                    $(".js-choose-lang-panel-mobile").removeClass("on");
                    $(".js-choose-lang-panel-mobile").removeClass("in");
                });

            // hide language switcher when clicking outside of it
            appAXFLOW.$document.on("click", function (e) {
                var $target = $(e.target);

                if (!$target.closest(appAXFLOW.$multiLangBtn).length) {
                    $(".language-switcher-container").addClass("hidden");
                }
            });

            // show / hide filters click event
            appAXFLOW.$document.on('click', '.js-show-hide-filters', function (e) {
                var productsColumn = $('.product-list-column');

                e.preventDefault();
                $('.js-filters').toggleClass('show-filters');
                $('.js-show-hide-filters').toggleClass('filters-on');

                if (productsColumn.hasClass('col-md-9')) {
                    productsColumn.removeClass('col-md-9').addClass('col-md-12');
                } else {
                    productsColumn.removeClass('col-md-12').addClass('col-md-9');
                }
            });

            

            appAXFLOW.$document.on("click", '.js-show-all-models',function (e) {
                $(".js-product-model").removeClass("hidden");
                $(".js-show-all-models").addClass("hidden");
                });

            appAXFLOW.$document.on('click', '.js-show-all-items', function (e) {

                $(".js-product-item").removeClass("hidden");
                $(".js-show-all-items").addClass("hidden");
            });

            appAXFLOW.$showAllSparePartKitsButton.on("click",
                function (e) {
                    $(".js-sparepart-kit").removeClass("hidden");
                    appAXFLOW.$showAllSparePartKitsButton.addClass("hidden");
                });

            appAXFLOW.$showAllAccessoriesButton.on("click",
                function (e) {
                    $(".accessory-part").removeClass("hidden");
                    appAXFLOW.$showAllAccessoriesButton.addClass("hidden");
                });
            appAXFLOW.$showAllSparepartsButton.on("click",
                function (e) {

                    if ($(this).hasClass('js-show-all-sparepartkits')) {
                        $('.js-sparepartkits .js-sparepart').removeClass('hidden');
                    } else if ($(this).hasClass('js-show-all-accessories')) {
                        $('.js-accessories .js-sparepart').removeClass('hidden');
                    } else {
                        $('.js-spareparts .js-sparepart').removeClass('hidden');
                       
                    }
                    $(this).addClass('hidden');

                    
                });
            appAXFLOW.$showAllDocumentsButton.on("click",
                function (e) {
                    $(".js-document").removeClass("hidden");
                    appAXFLOW.$showAllDocumentsButton.addClass("hidden");
                });
            appAXFLOW.$showAllSearchPageDocuments.on("click", function (e) {
                $(this).siblings(".downloads-document").removeClass("hidden");
                $(this).addClass("hidden");
            });
            // show more related products
            appAXFLOW.$document.on('click', '.js-show-realated-products', function (e) {
                e.preventDefault();
                //console.log("related products");

                $('.product-list__related').toggleClass('active');
                $('.js-show-realated-products').toggleClass('active');
            });

            // show / hide subcategories on product selector - highlight selected category parent
            $('.products').on('click', '.js-show-hide-subcategories', function (e) {
                e.preventDefault();
                $(this).parent().toggleClass('selected');
                appAXFLOW.checkSelected();
            });

            //show / hide country list on global homepage with country selector
            $('.js-country-selector').on('click', function (e) {
                e.preventDefault();
                $('.js-country-list').toggleClass('on');
                if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                    var target = $(this.hash);
                    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                    if (target.length) {
                        appAXFLOW.$htmlBody.animate({
                            scrollTop: target.offset().top
                        }, 500, function () {
                            // callback
                        });
                        // window.location.hash = this.hash;
                        return false;
                    }
                }
            });

            $('.sticky-item.lang').on('click', function (e) {
                e.preventDefault();
                $('.js-lang').trigger('click');
                appAXFLOW.scrollOn = false;
                // scroll to top
                appAXFLOW.$htmlBody.animate({ scrollTop: 0 }, 500, function () {
                    appAXFLOW.scrollOn = true;
                });
            });
            $('.sticky-item.search').on('click', function (e) {
                e.preventDefault();
                $('.js-search').trigger('click');
                // scroll to top
                appAXFLOW.$htmlBody.animate({ scrollTop: 0 }, 500);
            });
            $('.sticky-item.login-form').on('click', function (e) {
                e.preventDefault();
                $('.js-login-form').trigger('click');
                // scroll to top
                appAXFLOW.$htmlBody.animate({ scrollTop: 0 }, 500);
            });

            $('.youtube-player div').on('click', function () {
                var dataId = $(this).data('id');
                var iframe = '<iframe src="https://www.youtube.com/embed/' + dataId + '?autoplay=1" frameborder="0" allowfullscreen="1">';
                $(this).replaceWith(iframe);
            });

            appAXFLOW.$document.on('click', '.js-show-more', function (e) {
                var $this = $(this);
                e.preventDefault();

                var url = $this.data('url'),
                    languageCode = $this.data('language-code'),
                    nextPage = $this.data('next-page'),
                    contentGuid = $this.data('content-guid');

                $.ajax({
                    type: 'GET',
                    data: {
                        contentGuid: contentGuid,
                        languageCode: languageCode,
                        nextPage: nextPage
                    },
                    url: url,
                    dataType: 'html',
                    success: function (data) {
                        if (data != null && data.length > 0) {
                            $this.replaceWith(data);
                        }
                    },
                    error: function () {
                        console.error('More items could not be loaded.');
                    }
                });
                return false;
            });

            $('.js-available-countries').change(function () {
                var $selectedOption = $(this).find('option:selected');
                var selectedCountryCode = $selectedOption.val();
               

                $('.js-career-item').each(function () {
                    var $careerItem = $(this);
                    var shouldCareerBeShown = selectedCountryCode === '' ||
                        selectedCountryCode === $careerItem.data('country');

                    //Added for dot.com
                    if ($('.js-available-countries').hasClass('js-available-countries-dotcom')) {
                        if (selectedCountryCode == "default") {
                            shouldCareerBeShown = true;
                        }
                    }
                    //

                    if (shouldCareerBeShown) {
                        $careerItem.show();
                    } else {
                        $careerItem.hide();
                    }
                });
                
            });

            $('.js-sparepart-list-info-link').on('click', function (e) {
                e.preventDefault();
                $(this).addClass('active');
                $(this).siblings('.js-info-text-container').addClass('active');
            });


            $('.js-close-global-lang').on('click', function (e) {
                e.preventDefault();
                appAXFLOW.hideSplashScreen();
            });



            appAXFLOW.$document.on('click', '.reset-filters', function (e) {
                var $this = $(this);
                e.preventDefault();
                $('ul.categories li').removeClass('selected');
                appAXFLOW.getFilteredData($this, true, appAXFLOW.RangeFilterInUse);
            });

            appAXFLOW.$document.on('click', '.js-facet-filter', function (e) {
                var $this = $(this);
                e.preventDefault();

                var facetid = $this.attr("data-facet-id");
                if (facetid != "js-pressure-category" && facetid != "js-flow-capacity" && facetid != "js-port-size-category") { 
                    $('.categories').find("[data-facet-id='" + facetid + "']").closest('li').toggleClass('selected');
                }
               
                appAXFLOW.getFilteredData($this);

                if ((typeof $(".QueryStringField") !== 'undefined') && (typeof $(".QueryStringField").val() !== 'undefined')) {
                    $(".QueryStringField").val(window.location.href);
                }
            });

            appAXFLOW.$document.on('click', '.js-show-more-chunk', function (e) {
                var $this = $(this);
                e.preventDefault();

                //Light up spinner!!
                $this.prev('.js-show-spinner').addClass("show-spinner");

                var url = $this.data('url'),
                    segmentTypeId = $this.data('segment-type-id'),
                    pageNumber = $this.data('page-number'),
                    currentLanguage = $this.data('current-language'),
                    searchText = $this.data('search-text'),
                    rootCodeId = $this.data('root-code-id'),
                    catalogConnectionId = $this.data('catalog-connection-id'),
                    cvlKey = $this.data('cvl-key'),
                    seriesList = $this.data('series-list'),
                    pageType = $this.data('page-type'),
                    pageId = $this.data('page-id'),
                    hideList = $this.data('hide-list'),
                    hideFilterfields = $this.data('hide-filterfields'),
                    showPortSize = $this.data('show-portsize');

                var facet = [];
                $.each($this[0].attributes, function (e) {
                    var facetAttr = $(this)[0];
                    if (facetAttr.name.indexOf('data-facet-') >= 0) {
                        var facetName = facetAttr.name.split('-')[2];
                        var facetValue = facetAttr.nodeValue;
                        if (facetValue) {
                            facet.push(facetName + '__' + facetValue);
                        }
                    }
                });

                var facetOneString = facet.toString();
                var isSearchPage = appAXFLOW.$searchPage.length > 0 ? true : false;
                $.ajax({
                    type: 'GET',
                    data: {
                        segmentTypeId: segmentTypeId,
                        pageNumber: pageNumber,
                        currentLanguage: currentLanguage,
                        searchText: searchText,
                        rootCodeId: rootCodeId,
                        facetsList: facetOneString,
                        onlyProducts: !isSearchPage,
                        catalogConnectionId: catalogConnectionId,
                        cvlKey: cvlKey,
                        seriesList: seriesList,
                        pageType: pageType,
                        pageId: pageId,
                        hideList: hideList,
                        hideFilterfields: hideFilterfields,
                        showPortSize: showPortSize,
                        capacity: appAXFLOW.generateSearchCapacity(),
                        pressure: appAXFLOW.generateSearchPressure(),
                        portsize: appAXFLOW.generateSearchPortSize()
                    },
                    url: url,
                    dataType: 'html',
                    success: function (data) {
                        if (data != null && data.length > 0) {
                            $this.parent().replaceWith(data);
                        }
                    },
                    error: function () {
                        console.error('More items could not be loaded.');
                    }
                });
            });

            // show more models and items for generic product
            appAXFLOW.$document.on('click', '.js-show-moreMAI-chunk', function (e) {
                var $this = $(this);
                e.preventDefault();

                //Light up spinner!!
                $this.prev('.js-show-spinner').addClass("show-spinner");

                var url = $this.data('url'),
                    segmentTypeId = $this.data('segment-type-id'),
                    currentLanguage = $this.data('current-language'),
                    contentLinkId = $this.data('contentlinkid');

                var facet = [];
                $.each($this[0].attributes, function (e) {
                    var facetAttr = $(this)[0];
                    if (facetAttr.name.indexOf('data-facet-') >= 0) {
                        var facetName = facetAttr.name.split('-')[2];
                        var facetValue = facetAttr.nodeValue;
                        if (facetValue) {
                            facet.push(facetName + '__' + facetValue);
                        }
                    }
                });

                var facetOneString = facet.toString();
                $.ajax({
                    type: 'GET',
                    data: {
                        segmentTypeId: segmentTypeId,
                        currentLanguage: currentLanguage,
                        facetsList: facetOneString,
                        contentLinkID: contentLinkId,
                        capacity: appAXFLOW.generateSearchCapacity(),
                        pressure: appAXFLOW.generateSearchPressure(),
                        portsize: appAXFLOW.generateSearchPortSize()
                    },
                    url: url,
                    dataType: 'html',
                    success: function (data) {
                        $this.prev('.js-show-spinner').removeClass("show-spinner");
                        if (data != null && data.length > 0) {
                            $this.replaceWith(data);
                        }
                    },
                    error: function () {
                        $this.prev('.js-show-spinner').removeClass("show-spinner");
                        console.error('More items could not be loaded.');
                    }
                });
            });

            appAXFLOW.$document.on('click', '.js-btn-progress', function (e) {
                appAXFLOW.$formDescription.hide();
            });

            appAXFLOW.$formInputs.on('focus', function (e) {
                $(this).closest('label').find('span.js-label-text').removeClass('hidden');
            });

            appAXFLOW.$formInputs.on('keypress', function (e) {
                $(this).closest('label').find('span.js-label-text').addClass('white-label');
            });

            appAXFLOW.$navThirdLevel.on('click', function (e) {
                e.preventDefault();
                var $currentParent = $(this).parent();
                var $currentAnchor = $currentParent.find('> a');
                var $currentUl = $currentParent.next('ul');

                appAXFLOW.$navThirdLevel.parent().find('a').not($currentAnchor).removeClass('opened');
                appAXFLOW.$navThirdLevel.not($(this)).addClass('level-collapsed');
                appAXFLOW.$navThirdLevel.parent().next('ul').not($currentUl).removeClass('opened');

                $currentAnchor.toggleClass('opened');
                $(this).toggleClass('level-collapsed');
                $currentUl.toggleClass('opened');
            });

            appAXFLOW.$serviceButton.on('click', function (e) {
                e.preventDefault();
                if ($(".contact-form-content").length > 0) {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $(".contact-form-content").offset().top
                    }, 2000);
                    $(".contact-form-content option[value='ServiceInquiry']").attr("selected", "selected");
                }
            });

            $(".js-go-to-product-contact").on('click', function (e) {
                e.preventDefault();
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(".contact-form-content").offset().top
                }, 2000);
                $(".contact-form-content option[value='Quotation']").attr("selected", "selected");
            });
      

            $(document).ready(function () {
                if ($('.image-map').length !== 0) {

                    var spotImageUrlInfo;
                    var isExplodedDiagram;
                    var isHotSpotExplodedDiagram;

                    if (systemType == "Flowchart") {
                        spotImageUrlInfo = "true";
                    }
                    if (systemType == "ExplodedChart") {
                        isExplodedDiagram = true;
                    }

                    if (systemType == "HotSpotExplodedChart") {
                        isHotSpotExplodedDiagram = true;
                    }

                    function initFlow(image, options) {

                        if (!isExplodedDiagram) {
                            if (appAXFLOW.$flowchartImg.width() > 20) {
                                // console.log("if",image);
                                InRiverImageMap.initImageMap(image, options);
                            } else {
                                setTimeout(function () {
                                    //console.log("else",image);
                                    InRiverImageMap.initImageMap(image, options);
                                }, 1000);
                            }
                        } else {
                            if (appAXFLOW.$flowchartImg.width() > 20) {
                                // console.log("if",image);
                                InRiverImageMap.initImageMap(image, options);
                            } else {
                                setTimeout(function () {
                                    //console.log("else",image);
                                    InRiverImageMap.initImageMap(image, options);
                                }, 1000);
                            }

                        }  
                    }
                    if (!isHotSpotExplodedDiagram) {
                        initFlow(appAXFLOW.$flowchartImg, inRiverImageMapOptions);
                    }
                    appAXFLOW.$imageMapThumbnail.on('click', function (e) {

                        console.log("Clicked thumbnail systemtype:", systemType);

                        var number = $(this).data("order");
                        var imageMapDataTest = imageMapDataList[number];
                        var linkedEntitiesTest = linkedEntitiesList[number];
                        var systemTypeTest = systemType;

                        
                        //if ($('#exploadedViewSelect').length > 0) {
                        //    $('#exploadedViewSelect').html("");
                        //    $('#exploadedViewSelect').append($("<option>").attr('value', "default").text("Select sparepart"));

                        //    for (var i = 0; i < linkedEntitiesTest.length; ++i) {
                        //        $('#exploadedViewSelect').append($("<option>").attr('value', linkedEntitiesTest[i].manufacturerNumber).text((i + 1) + " " + linkedEntitiesTest[i].displayName));
                        //    }
                        //} 
                        var spotImageUrlInfo;
                        if (systemType == "Flowchart") {
                            spotImageUrlInfo = "true";
                        }
                        if (systemType == "ExplodedChart") {
                            var isExplodedDiagram = true;
                        }

                        // This is the options object for inRiver ImageMap
                        // Check the documentation on how to customise it to fit your needs
                        var inRiverImageMapOptions = {
                            imageMapData: imageMapDataTest, // Required
                            linkedEntities: linkedEntitiesTest,
                            systemType: systemTypeTest,
                            // imageWidth: 500,
                            // imageHeight: 500,
                            spotBackgroundColor: "#ED6B1D",
                            spotForegroundColor: "#fefefe",
                            spotImageUrl: spotImageUrlInfo,
                            onClick: function (area, e) {

                                // Find the linked enitity
                                var entity = $.grep(linkedEntitiesList[number],
                                    function (e) {
                                        return e.id == area.entityId;
                                    })[0];

                                // Show entity information
                                var productImage = $('.js-linked-product-image');
                                var manu = '';
                                var desc = '';
                                var materials = '';

                                if (entity.manufacturerNumber != '') {
                                    manu = '<p>' + entity.manufacturerNumber + '</p>';
                                }
                                if (entity.displayDescription != '') {
                                    desc = '<p>' + entity.displayDescription + '</p>';
                                }
                                if (entity.materials != '') {
                                    materials = '<p>' + entity.materials + '</p>';
                                }

                                if (entity.displayPicture == null) {
                                    productImage.addClass('hide');
                                } else {
                                    productImage.removeClass('hide');
                                }
                                productImage.attr('src', entity.displayPicture);
                                $('.js-linked-product-desc').html(manu + desc + materials);

                                var $productName = $('.js-linked-product-name');

                                $productName.html("<a href='" + entity.displayUrl + "'>" + entity.displayName + "</a>");
                                
                                //$('.js-exploaded-quote-button').attr('data-itemnumber', entity.manufacturerNumber).attr('data-productname', entity.displayName).attr("data-url", entity.displayUrl);

                                $(".block-modal").addClass("modal-active");
                                //var isExplodedDiagram = true;
                                if (isExplodedDiagram) {
                                    $(".block-modal").addClass("modal-active");
                                    //$(".block-modal").addClass("exploded-modal");
                                    var rect = e.target.getBoundingClientRect();
                                   
                                    var x = e.clientX - rect.left; //x position within the element.
                                    var y = e.clientY - rect.top;  //y position within the element.

                                    //$(".block-modal").css("left", x);
                                    //$(".block-modal").css("top", y);


                                    //document.getElementsByClassName('block-modal').onclick = function clickEvent(e) {
                                    //    consoele.log(e);
                                    //    // e = Mouse click event.
                                    //    var rect = e.target.getBoundingClientRect();
                                    //    var x = e.clientX - rect.left; //x position within the element.
                                    //    var y = e.clientY - rect.top;  //y position within the element.
                                    //    console.log("Left? : " + x + " ; Top? : " + y + ".");
                                    //}


                                }

                            },
                            onMouseOver: function (area, e) {
                                // Find the linked enitity
                             
                                var entity = $.grep(linkedEntitiesList[number],
                                    function (entity) {
                                        return entity.id == area.entityId;
                                    })[0];
                                if (entity) {
                                    $('.js-mouseover-text').html(entity.displayName);
                                    $('.js-linked-product-image-teaser').attr('src', entity.displayPicture);
                                    $('.flowchart-teaser').addClass('active');
                                }
                            },
                            onMouseOut: function (area, e) {
                                //$('.js-mouseover-text').html('');
                                //$('.js-linked-product-image-teaser').attr('src', '');
                                $('.flowchart-teaser').removeClass('active');
                            }
                        };


                        e.preventDefault();

                        appAXFLOW.$imageMapThumbnail.removeClass("active");
                        $(this).addClass("active");

                      
                        var flowChartImageContainer = $('.js-flowchart-image');
                        var teaser = flowChartImageContainer.find('.flowchart-teaser');
                        var image = $(this).find("img").clone();

                        flowChartImageContainer.html(image);
                        initExploadedChart();

                        function initExploadedChart() { 
                            if (image.width() > 20) {
                            InRiverImageMap.initImageMap(image, inRiverImageMapOptions);
                        } else {
                            setTimeout(function () {
                                InRiverImageMap.initImageMap(image, inRiverImageMapOptions);
                            },1000);
                            }
                        }
                        flowChartImageContainer.append(teaser);
                    });

                    if (!isHotSpotExplodedDiagram) {
                        $(window).on("orientationchange", function () {
                            initFlow(appAXFLOW.$flowchartImg, inRiverImageMapOptions);
                        });
                    }
                }
            });
        },

        toggleLanguagePanel: function () {
            appAXFLOW.$chooseLangBtn.toggleClass('active');
            appAXFLOW.$langsPanel.toggleClass('on');
            appAXFLOW.$chooseLangBtn.focusout();
        },

        toggleSearchPanel: function () {
            //if (!(appAXFLOW.$searchPanel.hasClass('on'))) {
            //    $('.js-search-panel input[type=text]').focus();
            //}
            //appAXFLOW.$searchBtn.toggleClass('active');
            //appAXFLOW.$searchPanel.toggleClass('on');
            //appAXFLOW.$searchBtn.focusout();
            //if (appAXFLOW.$searchPanel.hasClass('on')) {
            //    flexibility(document.getElementsByTagName('body')[0]);
            //}

            //appAXFLOW.$window.on('scroll', function () {
            //    if (!($('.js-search-panel').hasClass("on"))) {
            //        $('.ui-autocomplete').css("display", "none");
            //    }
            //});
        },

        onScrollEvent: function () {
            var scrollOffset;
            var navFixedPosition = $('header .logo-plus').innerHeight();
            var secondaryMenuPosition;
            appAXFLOW.$window.on('scroll', function () {
                scrollOffset = appAXFLOW.$document.scrollTop();
                if (window.matchMedia('(min-width: 992px)').matches) {
                    $('nav > ul > li > a').removeClass('active');
                    $('nav .sub-menu').removeClass('expanded');
                    if (scrollOffset > navFixedPosition &&
                        !appAXFLOW.$langsPanel.hasClass('on') && !appAXFLOW.$searchPanel.hasClass('on')) {
                        $('header nav').addClass('sticky');
                    } else {
                        $('header nav').removeClass('sticky');
                    }
                    if (!$('nav.secondary-menu').hasClass('sticky') && $('nav.secondary-menu').exists()) {
                        secondaryMenuPosition = appAXFLOW.calculateSecondaryMenuPosition($('nav.secondary-menu'));

                    }
                    if (scrollOffset > secondaryMenuPosition &&
                        !appAXFLOW.$langsPanel.hasClass('on') && !appAXFLOW.$searchPanel.hasClass('on')) {
                        $('nav.secondary-menu').css('top', $('header nav').innerHeight());
                        $('nav.secondary-menu').addClass('sticky');
                        $('section.product-section').addClass('sticky');
                        $('.js-product-list-page').css('padding-top', 87);
                    } else {
                        $('nav.secondary-menu').css('top', 'auto');
                        $('nav.secondary-menu').removeClass('sticky');
                        $('section.product-section').removeClass('sticky');
                        $('.js-product-list-page').css('padding-top', 0);
                    }
                    if (appAXFLOW.scrollOn) {
                        appAXFLOW.closeTopPanelsOnScroll();
                    }
                }
                appAXFLOW.calculateParallax();
            });
        },

        resetLoginModal: function () {
            $(".forgot-password").addClass("hidden");
            $(".request-new-account").addClass("hidden");
            $(".login-form").removeClass("hidden");
            $(".jsFpDiv").addClass("hidden");
            $('.forgot-password .formFP')[0].reset();

            $('.forgot-password .formFP')[1].reset();

            $('.request-new-account .formApply')[0].reset();
            $('.request-new-account .formApply')[1].reset();
            $('.js-success-unknown-user').addClass('hidden');
            $('.js-submit-request-new-account').removeClass('hidden');

            $('.applyThanks').addClass('hidden');
            $('.formApply').removeClass('hidden');
            $('.js-new-user-preamble').removeClass('hidden');


            $(".formFP .info").text("");
            $(".formFP .error").text("");
            $(".formApply .error").text("");
            $('.js-hide-on-end-page').removeClass('hidden');
            $(".formFP .js-close-login").addClass("hidden");
        },

        calculateParallax: function () {
            var t = - appAXFLOW.$window.scrollTop() / 2;

            $('.js-parallax').css('transform', 'translate3d(-50%,' + t + 'px, 0)');
        },

        closeTopPanelsOnScroll: function () {
            if (appAXFLOW.$langsPanel.hasClass('in') && appAXFLOW.$window.scrollTop() > 0) {
                appAXFLOW.$chooseLangBtn.trigger('click');
                appAXFLOW.$langsPanel.removeClass('in').removeClass('on');
            }
            if (appAXFLOW.$searchPanel.hasClass('in') && appAXFLOW.$window.scrollTop() > 0) {
                appAXFLOW.$searchBtn.trigger('click');
                appAXFLOW.$searchPanel.removeClass('in').removeClass('on');
            }
        },

        highlightMenuItemOnScroll: function () {
            // Cache selectors
            var lastId,
                topMenu = $('nav.main-nav'),
                secondaryMenu = $('nav.secondary-menu'),
                topMenuHeight = topMenu.outerHeight() + secondaryMenu.outerHeight(),
                // All list items
                secondaryMenuItems = secondaryMenu.find('a'),
                // Anchors corresponding to menu items
                scrollItems = secondaryMenuItems.map(function () {
                    var item = $($(this).attr('href'));
                    if (item.length) { return item; }
                });

            // Bind click handler to menu items
            // so we can get a fancy scroll animation
            secondaryMenuItems.on('click', function (e) {
                var href = $(this).attr('href'), offsetTop = href === '#' ? 0 : $(href).offset().top - topMenuHeight;

                appAXFLOW.$htmlBody.animate({
                    scrollTop: offsetTop
                }, 850);
                e.preventDefault();
            });

            // Bind to scroll
            appAXFLOW.$window.scroll(function () {

                // Get container scroll position
                var fromTop = $(this).scrollTop() + topMenuHeight;
                // Get id of current scroll item
                var cur = scrollItems.map(function () {
                    if ($(this).offset().top < (fromTop + 1))
                        return this;
                });
                // Get the id of the current element
                cur = cur[cur.length - 1];
                var id = cur && cur.length ? cur[0].id : '';

                if (id !== '' && lastId !== id) {
                    lastId = id;
                    // Set/remove active class
                    secondaryMenuItems.removeClass('sm-active');
                    secondaryMenuItems.each(function () {
                        if (this.hash === '#' + id) {
                            $(this).addClass('sm-active');
                            // window.location.hash = this.hash;
                        }
                    });
                }

            });
        },

        calculateSecondaryMenuPosition: function (element) {
            var secondaryMenuPosition = element.offset().top - $('header nav').innerHeight();
            return secondaryMenuPosition;
        },

        setResponsiveImages: function () {

            $('.js-responsive-image img').each(function (k, img) {
                var $img = $(img);
                var $parentDiv = $img.parent();
                if ($parentDiv.length > 0 && $parentDiv[0].nodeName != "DIV")
                    $parentDiv = $parentDiv.parent();
                var currentOrOriginal = appAXFLOW.getCurrentOrOriginalImgSrc($img);
                $parentDiv.css('background-image', 'url(\'' + currentOrOriginal.url + '\')');
            });
        },

        getCurrentOrOriginalImgSrc: function ($img) {
            var srcset = $img.attr('srcset');
            if (!srcset) {
                // Check if any sibling <source> has a srcset whose media query matches
                var $matchingSource = null;
                $img.siblings('source[srcset]').each(function () {
                    var media = $(this).attr('media');
                    if (!media || window.matchMedia(media).matches) {
                        $matchingSource = $(this);
                        return false; // break
                    }
                });
                if ($matchingSource) {
                    return { url: $matchingSource.attr('srcset') };
                }
                return { url: $img.attr('src') };
            }
            var parsetSrcSet = appAXFLOW.parse(srcset);
            parsetSrcSet.sort(function (a, b) {
                var aWidth = a.width, bWidth = b.width;
                if (aWidth === bWidth) return 0;
                return aWidth > bWidth ? 1 : -1;
            });
            var currentOrOriginal;
            if (window.matchMedia('(max-width: ' + parsetSrcSet[0].width + 'px)').matches) {
                currentOrOriginal = parsetSrcSet[0];
            } else {
                currentOrOriginal = parsetSrcSet[1];
            }
            return currentOrOriginal;
        },

        parse: function (str) {
            return appAXFLOW.deepUnique(str.split(',').map(function (el) {
                var ret = {};
                el.trim().split(/\s+/).forEach(function (el, i) {
                    if (i === 0) {
                        ret.url = el;
                        return ret.url;
                    }
                    var value = el.substring(0, el.length - 1);
                    var postfix = el[el.length - 1];
                    var intVal = parseInt(value, 10);
                    var floatVal = parseFloat(value);

                    if (postfix === 'w' && appAXFLOW.reInt.test(value)) {
                        ret.width = intVal;
                    } else if (postfix === 'h' && appAXFLOW.reInt.test(value)) {
                        ret.height = intVal;
                    } else if (postfix === 'x' && !isNaN(floatVal)) {
                        ret.density = floatVal;
                    } else {
                        throw new Error('Invalid srcset descriptor: ' + el + '.');
                    }
                });
                return ret;
            }));
        },

        deepUnique: function (arr) {
            return arr.sort().filter(function (el, i) {
                return JSON.stringify(el) !== JSON.stringify(arr[i - 1]);
            });
        },

        initSlickSlider: function () {
            $('.js-slider').slick({
                dots: true,
                infinite: true,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            centerMode: true
                        }
                    },
                    {
                        breakpoint: 640,
                        settings: {
                            centerMode: true,
                            arrows: false
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            arrows: false
                        }
                    }
                    // You can unslick at a given breakpoint now by adding:x
                    // settings: 'unslick'
                    // instead of a settings object
                ]
            });
        },
        initSlickSliderEcom: function () {
            $('.js-slider-ecom').slick({
                slidesToShow: 1,
                //slidesToScroll: 1,
                arrows: false,
                fade: true,
                asNavFor: '.js-slider-nav',
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            centerMode: true
                        }
                    },
                    {
                        breakpoint: 640,
                        settings: {
                            centerMode: true,
                            arrows: false
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            arrows: false
                        }
                    }
                    // You can unslick at a given breakpoint now by adding:x
                    // settings: 'unslick'
                    // instead of a settings object
                ]

            });
            $('.js-slider-nav').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                asNavFor: '.js-slider-ecom',
                arrows: false,
                dots: true,
                centerMode: true,
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            centerMode: true
                        }
                    },
                    {
                        breakpoint: 640,
                        settings: {
                            centerMode: true,
                            arrows: false
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            arrows: false
                        }
                    }
                    // You can unslick at a given breakpoint now by adding:x
                    // settings: 'unslick'
                    // instead of a settings object
                ]
            });
        },

        addFileTypeClass: function () {
            $('.js-related-list a').each(function (index, elem) {
                var href = $(this).attr('href');
                if (href.endsWith('.pdf')) {
                    $(this).addClass('pdf');
                    $(this).attr("target", "_blank");
                }
            });
        },

        bootstrapHoverTabs: function () {

            $('header nav.main-nav .dropdown .columns .column.tabs > ul > li a').mouseenter(function () {
                appAXFLOW.expandMenu(this);
            });

            $('header nav.main-nav .dropdown .columns .column.tabs > ul > li a').mouseout(function () {
                appAXFLOW.killMenu(this);
            });
        },

        expandMenu: function (obj) {
            clearTimeout(appAXFLOW.expandMenuTimer);
            appAXFLOW.expandMenuTimer = setTimeout(function () { $(obj).tab('show'); }, 350);
        },

        killMenu: function () {
            clearTimeout(appAXFLOW.expandMenuTimer);
        },

        generateSearchFacets: function () {

            var jsonObj = [];

            var facetsGroup = $('ul.categories').children('li').each(function (e) {
                var facetgroupElement = $(this)[0];
                var item = {};
                var itemlist = "";
                var facets = $(this).find("li.selected").each(function (e) {
                    itemlist = itemlist + '|' + $(this).find('a').data('facet-id');
                });

                if (itemlist.length > 0) {
                    if (itemlist.substring(1) != "undefined") { 
                        var encodedItemList = encodeURIComponent(itemlist.substring(1));

                        //jsonObj.push(facetgroupElement.id + '__' + itemlist.substring(1));
                        jsonObj.push(facetgroupElement.id + '__' + encodedItemList);
                    }
                    //jsonObj.push(facetgroupElement.id + '__' + itemlist.substring(1));
                }
            });
            return jsonObj.toString();
        },

        generateSearchCapacity: function (reset) {

            if (reset) {
                return '';
            }
            //var urlString = window.location.href;
            ////VARNING - FUNKAR EJ I IE 
            //var url = new URL(urlString);
            var minField = $('input#min');
            var maxField = $('input#max');
            var unitField = $('input.filter-checkbox:checked');

            if (typeof minField.val() === 'undefined') {
                return "";
            }

            var min = minField != null && minField.val() !== "" ? "&min=" + minField.val() : "";
            var max = maxField != null && maxField.val() !== "" ? "&max=" + maxField.val() : "";
            var unit = unitField.length !== 0 ? "&unit=" + unitField.val() : "";

            if (min === "" && max === "") {
                return "";
            }

            return min + max + unit;
        },

        generateSearchPressure: function (reset) {

            if (reset) {
                return '';
            }
            //var url = new URL(urlString);
            var maxField = $('input#pmax');
            var unitField = $('input.p-filter-checkbox:checked');

            if (typeof maxField.val() === 'undefined') {
                return "";
            }

            var max = maxField != null && maxField.val() !== "" && maxField.val() !== "0" ? "&pmax=" + maxField.val() : "";
            var unit = unitField.length != 0 ? "&punit=" + unitField.val() : "";

            if (max === "") {
                return "";
            }

            return max + unit;
        },

        generateSearchPortSize: function (reset) {

            if (reset) {
                return '';
            }

            var portSizeField = $('input.ps-filter-checkbox:checked');

            if (typeof portSizeField.val() === 'undefined') {
                return "";
            }

            var portSize = portSizeField.length != 0 ? "&psize=" + portSizeField.val() : "";

            return portSize;
        },

        initModelImageSwapper: function () {
            var $images = $('.js-image-swapper');
            var $target = $('.js-main-image-swap');
            $images.on("click",
                function (e) {
                    e.preventDefault();
                    var imgSrc = this.children[0].src;
                    $images.removeClass("active");
                    $($(this).addClass("active"));
                    $target.attr('src', imgSrc);
                });
        },

        initAvailableDates: function () {
            var $dates = $('.delivery-date');
            $dates.each(function () {
                if ($(this).data("companyid") == "0") return;
                if ($(this).data("companyid") == undefined) return;
                if ($(this).data("qty") < "0") return;  
                var $this = $(this);
                var qty = $this.data("qty");

                $.ajax({
                    type: 'GET',
                    url: '/axb/product/availability?companyId=' + $this.data("companyid") + '&code=' + $this.data("code") + '&qty=' + qty,
                    dataType: 'json',
                    cache: false,
                    success: function (data) {
                        if (data != null && data != "") {
                            if (data.InStock != null && data.InStock.length > 0) {
                                $this.find(".deeT .eeT").text(data.InStock);
                                $this.find(".deeT").show();
                                $this.find(".expected-delivery-header").show();
                                $this.find(".delivery-shipping").show();
                            } else if (data.Incoming != null && data.Incoming.length > 0) {
                                $this.find(".deT .eT").text(data.Incoming);
                                $this.find(".deT").show();
                                $this.find(".expected-delivery-header").show();
                                $this.find(".delivery-shipping").show();
                            }
                        } else {
                            //$this.find(".dnaT").show();
                        }
                        $("img", $this.parent()).hide();
                    },
                    error: function () {
                        //$this.find(".dnaT").show();
                        $this.parent().hide();
                    }
                });
            });
        },
        recheckAvailableDates: function (quantity) {
            $('.deeT').hide();
            $('.deT').hide();
            $('.delivery-date').hide();
            $('.expected-delivery-img').show();
            $(".deeT .eeT").text("");
            $(".deT .eT").text("");

            var $dates = $('.delivery-date');
            $dates.each(function () {
                if ($(this).data("companyid") == "0") return;
                if ($(this).data("qty") < "0") return;
                var $this = $(this);
                var qty = quantity;
                
                $.ajax({
                    type: 'GET',
                    url: '/axb/product/availability?companyId=' + $this.data("companyid") + '&code=' + $this.data("code") + '&qty=' + qty,
                    dataType: 'json',
                    cache: false,
                    success: function (data) {
                        if (data != null && data != "") {
                            $('.delivery-date').show();
                            if (data.InStock != null && data.InStock.length > 0) {
                                $this.find(".deeT .eeT").text(data.InStock);
                                $this.find(".deeT").show();
                                $this.find(".expected-delivery-header").show();
                                $this.find(".delivery-shipping").show();
                            } else if (data.Incoming != null && data.Incoming.length > 0) {
                                $this.find(".deT .eT").text(data.Incoming);
                                $this.find(".deT").show();
                                $this.find(".expected-delivery-header").show();
                                $this.find(".delivery-shipping").show();
                            }
                        } else {
                            //$this.find(".dnaT").show();
                        }
                        $("img", $this.parent()).hide();
                    },
                    error: function () {
                        //$this.find(".dnaT").show();
                        $this.parent().hide();
                    }
                });
            });

        },
        recheckAvailabilityDateCheckout: function () {
            var checkoutView = document.getElementById("CheckoutView");
            if (!checkoutView) {
                return;
            }
            //showspinner
            $('.expected-delivery-checkout-img').show();
            $('#spinner').show();
            $("#delivery-date-container").text("");
            var querystring = "";
            var products = $('.cart-row');
            var companyId = $('#CheckoutView').data("companyid");
            var dispatchDateError = $('#CheckoutView').data("dispatcherror");

            products.each(function () {
                var code = $(this).find("#code").val();
                var quant = $(this).find("#quantity").val();
                querystring += code + "," + quant + ";";
            });
            querystring = querystring.slice(0, -1);

            $.ajax({
                type: 'GET',
                url: '/axb/products/availability?productsMap=' + querystring + '&' + 'companyId=' + companyId ,
                dataType: 'json',
                cache: false,
                success: function (data) {
                    if (data != null && data != "") {
                        $('.delivery-date').show();
                        $("#delivery-date-container").text(data);
                        $("#BillingAddress_AvailabilityDate").val(data);
                        $('.expected-delivery-checkout-img').hide();
                        $('#spinner').hide();
                    } else {
                        //$("#delivery-date-container").text("Error fetching availability date");
                        $("#delivery-date-container").text(dispatchDateError);
                    }
                    //hide spinner
                    $('.expected-delivery-checkout-img').hide();
                    $('#spinner').hide();
                },
                error: function () {
                    $('#spinner').hide();
                    //$("#delivery-date-container").text("Error fetching availability date");
                    $("#delivery-date-container").text(dispatchDateError);
                }
            });
        },
        initCustomerPrice: function () {
            var $prices = appAXFLOW.$customerPrice;
            $prices.each(function () {
                if (typeof $(this).data("code") === 'undefined') return;
                if (typeof $(this).data("companyid") === 'undefined') return;
                if (typeof $(this).data("crmid") === 'undefined') return;
                var $this = $(this);
                $.ajax({
                    type: 'GET',
                    url: '/prices/GetCustomerPrice?c=' + $this.data("code") + '&coId=' + $this.data("companyid") + '&crId=' + $this.data("crmid") + '&lang=' + $('html')[0].lang,
                    headers: { 'AxbusApi': '' },
                    dataType: 'json',
                    cache: false,
                    success: function (data) {
                        var c = false;
                        if (data != null && data != "") {
                            $this.html(data.PS);
                            $this.siblings('.js-discount').removeClass("hidden");
                            $this.siblings('.js-discount').find('span').html(data.Discount);
                            if ($this.hasClass("acces")) {
                                $this.parent().siblings('.accessories-vat-and-discount').find('.js-discount span').html(data.Discount);
                            }
                            else if ($this.hasClass("spart")) {
                            }
                            else {
                                $(".jsAddToCart").removeClass("hidden");
                            }
                        } else if ($this.hasClass("spart")) {
                            $this.html("");
                            $this.siblings('.js-pricing-quotedSP').removeClass('hidden');
                            $this.parents('.spare-part-price-info').siblings('.spare-part-add-to-cart').find('.jsAC').addClass('hidden');
                        }
                        else if ($this.hasClass("acces")) {
                            $this.html("");
                            $this.parent().siblings('.accessories-vat-and-discount').addClass('hidden');
                        }
                        else {
                            $this.html("");
                            $('.js-pricing-quoted').removeClass('hidden');
                            $this.siblings('.js-excluding-vat-text').addClass('hidden');
                            $('.js-border-container').addClass('noprice');
                            $('.js-amount-holder').removeClass('col-md-4 no-padding amount-holder');
                            $('.js-price').addClass('hidden');
                        }
                    },
                    error: function () {
                        console.log("error in customerprice");
                    }
                });
            });
        },


        initSearchTabs: function () {
            var $dates = $('.searchTop span');
            $dates.click(function () {
                var $this = $(this);
                var currSel = $('.searchTop span.sel');
                if ($this[0] != currSel[0]) {
                    currSel.removeClass("sel");
                    $this.addClass("sel");
                    $(".component." + currSel.data("class")).hide();
                    $(".component." + $this.data("class")).show();
                }
            });

            //simulate click on the first tab with content
            var $tabs = $('.js-search-tab');
            var selected = false;
            $tabs.each(function () {
                if (!selected) {
                    if ($(this).data("hits") > 0) {
                        $(this).trigger('click');
                        selected = true;
                    }
                }
            });
        },

        initRangeSlider: function () {
            //initSliders();
            initFromQueryParams();
            initRadiobuttonListener();
            initSubmitterListener();
            appAXFLOW.setFilter();
          
            if (appAXFLOW.RangeFilterInUse > 0) {
                if (appAXFLOW.FlowCapacityFilterInUse > 0) {
                    $('.js-flow-capacity').addClass("selected");
                }
                if (appAXFLOW.PressureFilterInUse > 0) {
                    $('.js-pressure-category').addClass("selected");
                }
                if (appAXFLOW.PortSizeFilterInUse > 0) {
                    $('.js-port-size-category').addClass("selected");

                }

                //$('.flow-wrapper').addClass("selected");
            }

            //Reset button
            $(".reset-flow-filter").on("click", function (e) {
                e.preventDefault();
                resetFlowForm();

            });

            //reset pressure button
            $(".reset-pressure-filter").on("click", function (e) {
                e.preventDefault();
                resetPressureForm();
            });

            //reset portsize button
            $(".reset-portsize-filter").on("click", function (e) {
                e.preventDefault();
                resetPortSizeForm();
            });


            function getVals() {
                // Get slider values
                //var slides = document.getElementsByClassName("value1");
                //var slide1 = parseFloat(slides[0].value);
                //var slide2 = parseFloat(slides[1].value);

                // Neither slider will clip the other, so make sure we determine which is larger
                //if (slide1 > slide2) { var tmp = slide2; slide2 = slide1; slide1 = tmp; }

                var displayElement1 = document.getElementById("min");
                var displayElement2 = document.getElementById("max");

                //displayElement1.setAttribute("value", slide1);
                //displayElement2.setAttribute("value", slide2);
            }
            function initFromQueryParams() {
                //init stuff from queryparam
                $.urlParam = function (name) {
                    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
                    if (results == null) {
                        return null;
                    } else {
                        return decodeURI(results[1]) || 0;
                    }
                };



                //const urlParams = new URLSearchParams(window.location.search);'

                //FLOW below

                var initialMinValue = $.urlParam('min');
                var initialMaxValue = $.urlParam('max');
                var initialUnit = $.urlParam('unit');

                $('input.filter-checkbox').first().prop('checked', true);

                var displayElement1 = document.getElementById("min");
                var displayElement2 = document.getElementById("max");
                var slides = document.getElementsByClassName("value1");


                if (initialMinValue && displayElement1 != null) {
                    displayElement1.setAttribute("value", initialMinValue);
                    //slides[0].setAttribute("value", initialMinValue);

                    if (initialUnit) {
                        var strMin = 'input#' + initialUnit;
                        var min = $(strMin).data("min");
                        //slides[1].setAttribute("min", min);
                    }

                }
                if (initialMaxValue && displayElement2 != null) {
                    displayElement2.setAttribute("value", initialMaxValue);
                    //slides[1].setAttribute("value", initialMaxValue);

                    if (initialUnit) {
                        var strMax = 'input#' + initialUnit;
                        var max = $(strMax).data("max");
                        //slides[1].setAttribute("max", max);
                    }


                }
                if (initialUnit) {
                    var str = 'input#' + initialUnit;
                    $(str).prop('checked', true);
                    var newMin = $(str).data("min");
                    var newMax = $(str).data("max");


                    //displayElement1.setAttribute("value", newMin);
                    //displayElement2.setAttribute("value", newMax);
                }
                //FLOW Above

                //PRESURE below

                var initialPressureMaxValue = $.urlParam('pmax');
                var initialPressureUnit = $.urlParam('punit');
                var initialPortSize = $.urlParam('psize');

                //$('input.filter-checkbox').first().prop('checked', true);

                var pdisplayElement = document.getElementById("pmax");

                if (pdisplayElement != null) {
                    if (initialPressureMaxValue) {
                        pdisplayElement.setAttribute("value", initialPressureMaxValue);
                    }
                }

                if (initialPressureUnit) {
                    var pstr = 'input#' + initialPressureUnit.toLowerCase();
                    $(pstr).prop('checked', true);
                    var pnewMax = $(pstr).data("max");


                    //displayElement1.setAttribute("value", newMin);
                    if (pdisplayElement != null) {
                        pdisplayElement.setAttribute("value", initialPressureMaxValue);
                    }
                }
                //End pressure

            }


            function initSliders() {
                // Initialize Sliders
                var sliderSections = document.getElementsByClassName("option-slider");
                for (var x = 0; x < sliderSections.length; x++) {
                    var sliders = sliderSections[x].getElementsByTagName("input");
                    for (var y = 0; y < sliders.length; y++) {
                        if (sliders[y].type === "range") {
                            sliders[y].oninput = getVals;
                            // Manually trigger event first time to display values
                            sliders[y].oninput();
                        }
                    }
                }
            }

            function resetFlowForm() {

                //appAXFLOW.RangeFilterInUse = 0;
                appAXFLOW.FlowCapacityFilterInUse = 0;

                var displayElement1 = document.getElementById("min");
                var displayElement2 = document.getElementById("max");

                displayElement1.setAttribute("value", "");
                displayElement2.setAttribute("value", "");

                appAXFLOW.getFilteredData($('.js-flow-capacity .js-submitter'));
            }


            function resetPressureForm() {
                //appAXFLOW.RangeFilterInUse = 0;
                appAXFLOW.PressureFilterInUse = 0;
                var displayElement2 = document.getElementById("pmax");

                //var newMax = $(".filter-checkbox:checked").data("");
                displayElement2.setAttribute("value", "");

                appAXFLOW.getFilteredData($('.js-pressure-category .js-submitter'));
            }

            function resetPortSizeForm() {
                //appAXFLOW.RangeFilterInUse = 0;
                appAXFLOW.PortSizeFilterInUse = 0;
                $(".js-port-size input[type='radio']:checked").prop('checked', false);
                appAXFLOW.getFilteredData($('.js-port-size-category .js-submitter'));
            }

            //init radiobutton listener and handles on change
            function initRadiobuttonListener() {
                var buttons = $(".filter-checkbox");
                buttons.change(function () {
                    var newMin = $(".filter-checkbox:checked").data("min");
                    var newMax = $(".filter-checkbox:checked").data("max");

                    var displayElement1 = document.getElementById("min");
                    var displayElement2 = document.getElementById("max");
                    //var slides = document.getElementsByClassName("value1");

                    displayElement1.setAttribute("value", newMin);
                    //slides[0].setAttribute("min", newMin);
                    //slides[0].setAttribute("value", newMin);
                    //slides[1].setAttribute("min", newMin);

                    displayElement2.setAttribute("value", newMax);
                    //slides[0].setAttribute("max", newMax);
                    //slides[1].setAttribute("max", newMax);
                    //slides[1].setAttribute("value", newMax);
                });
            }
            function initSubmitterListener() {
                $(".js-submitter").on("click",
                    function (e) {
                        appAXFLOW.RangeFilterInUse = 1;
                        if ($(this).data("facet-id") == "flowCapacity") { 
                            appAXFLOW.FlowCapacityFilterInUse = 1;
                        }
                        if ($(this).data("facet-id") == "pressure") {
                            appAXFLOW.PressureFilterInUse = 1;
                        }
                        if ($(this).data("facet-id") == "portSize") {
                            appAXFLOW.PortSizeFilterInUse = 1;
                        }
                    });
            }
        },
        initLanguagePopUp: function () {
            if (!sessionStorage.showLanguagePopup) {
                //$('.language-selector-helper').addClass("visible");
            }
            $(".js-decline-change-language-button").on("click",
                function () {
                    sessionStorage.showLanguagePopup = true;
                    $('.language-selector-helper').removeClass("visible");
                    $('.language-selector-helper').addClass("hidden");
                });
            $(".js-accept-change-language-button").on("click",
                function () {
                    sessionStorage.showLanguagePopup = true;
                });
        },


        getFilteredData: function (el, reset, includeRangeFilter) {

            var inputFilter = {
                url: el.data('url'),
                segmentTypeId: el.data('segment-type-id'),
                currentLanguage: el.data('current-language'),
                rootCodeId: el.data('root-code-id'),
                catalogConnectionId: el.data('catalog-connection-id'),
                cvlKey: el.data('cvl-key'),
                seriesList: el.data('series-list'),
                pageType: el.data('page-type'),
                pageId: el.data('page-id'),
                hideList: el.data('hide-list'),
                hideFilterfields: el.data('hide-filterfields'),
                showPortSize: el.data('show-portsize'),
                filter: appAXFLOW.generateSearchFacets(),
                capacity: appAXFLOW.generateSearchCapacity(reset),
                pressure: appAXFLOW.generateSearchPressure(reset),
                portsize: appAXFLOW.generateSearchPortSize(reset)
            };
            //ToDo: do not send capacity and pressure form data if not necessary
            if (appAXFLOW.RangeFilterInUse == 0) {
                //inputFilter.capacity = "";
            }
           

            window.history.pushState(null, '', '?filter=' + inputFilter.filter + inputFilter.capacity + inputFilter.pressure + inputFilter.portsize);
            if (reset) {
                window.history.pushState(null, '', '');
                appAXFLOW.FlowCapacityFilterInUse = 0;
                appAXFLOW.PressureFilterInUse = 0;
                appAXFLOW.PortSizeFilterInUse = 0;
            } 
            //TODO fix so that the min max doesnt send the wrong url. 
            $.ajax({
                type: 'GET',
                url: inputFilter.url,
                data: {
                    segmentTypeId: inputFilter.segmentTypeId,
                    currentLanguage: inputFilter.currentLanguage,
                    rootCodeId: inputFilter.rootCodeId,
                    catalogConnectionId: inputFilter.catalogConnectionId,
                    cvlKey: inputFilter.cvlKey,
                    seriesList: inputFilter.seriesList,
                    pageType: inputFilter.pageType,
                    pageId: inputFilter.pageId,
                    hideList: inputFilter.hideList,
                    hideFilterfields: inputFilter.hideFilterfields,
                    showPortSize: inputFilter.showPortSize,
                    facetsList: inputFilter.filter,
                    capacity: inputFilter.capacity,
                    pressure: inputFilter.pressure,
                    portsize: inputFilter.portsize
                },
                dataType: 'html',
                success: function (data) {
                    if (data != null && data.length > 0) {

                        var checkClass = data;
                        var idCheck;
                        var idReplace;

                        // This function is for saving the state of the filter list to be hidden or visible
                        // It checks on classnames and IDs so be careful when changing these in the .cshtml 

                        $('ul.categories > li').each(function (i, v) {
                       
                            if (!$(v).hasClass("selected")) {

                                idCheck = 'id="' + $(v).attr('id') + '" ' + 'class="selected ';
                                idReplace = 'id="' + $(v).attr('id') + '" ' + 'class="active-children ' + "";

                                checkClass = checkClass.replace(idCheck, idReplace);
                            }
                        });

                        el.closest('.results').replaceWith(checkClass);
                        appAXFLOW.initRangeSlider();
                        if (includeRangeFilter) {
                            $('.flow-wrapper').removeClass('selected');
                        }
                    }
                },
                error: function () {
                    console.error('More items could not be loaded.');
                }
            });

            $('html, body').animate({
                scrollTop: ($('#js-scroll-top').offset().top - 60)
            }, 900);
        },


        showSplashScreen: function () {
            appAXFLOW.$body.removeClass('homepage');
            appAXFLOW.$body.addClass('global-homepage');
            $('.js-lang-splash').removeClass('hidden');
            $('.js-splash-cover').addClass('hidden');
            appAXFLOW.$main.addClass('hidden');
            appAXFLOW.$header.addClass('hidden');
        },

        hideSplashScreen: function () {
            localStorage.hideSplash = true;

            appAXFLOW.$body.addClass('homepage');
            appAXFLOW.$body.removeClass('global-homepage');
            $('.js-lang-splash').addClass('hidden');
            appAXFLOW.$main.removeClass('hidden');
            appAXFLOW.$header.removeClass('hidden');

            appAXFLOW.scrollOn = false;
            // scroll to top
            appAXFLOW.$htmlBody.animate({
                scrollTop: 0
            }, 500, function () {
                appAXFLOW.scrollOn = true;
            });
        },
        initLinkDataLayer: function () {
            //$('.downloads-document').on("click",
            //    function () {
            //       var name =  $(this).text();
            //        window.dataLayer = window.dataLayer || [];
            //        window.dataLayer.push({
            //            'event': 'pdfClick',
            //            'pdfName': name
            //        });
            //    });
        },

        checkSelected: function () {
            var selected = $('.filters-wrapper li.selected');
            selected.parent().parent().addClass("active-children");
        },
        fixWidthSingOutButton: function () {
            var width = $('.sho').width() + 10;
            $('.login-header.js-login-header.True').width(width);
        }
    };

    $.fn.exists = function () {
        return this.length > 0;
    };

})(this, jQuery);

if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

document.addEventListener("DOMContentLoaded", function () {
    var lazyloadImages;
    if ("IntersectionObserver" in window) {
        lazyloadImages = document.querySelectorAll(".lazyl");
        var imageObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    var image = entry.target;
                    image.classList.remove("lazyl");
                    imageObserver.unobserve(image);
                }
            });
        });

        lazyloadImages.forEach(function (image) {
            imageObserver.observe(image);
        });
    } else {
        var lazyloadThrottleTimeout;
        lazyloadImages = document.querySelectorAll(".lazyl");

        function lazyload() {
            if (lazyloadThrottleTimeout) {
                clearTimeout(lazyloadThrottleTimeout);
            }

            lazyloadThrottleTimeout = setTimeout(function () {
                var scrollTop = window.pageYOffset;
                lazyloadImages.forEach(function (img) {
                    if (img.offsetTop < (window.innerHeight + scrollTop)) {
                        img.classList.remove('lazyl');
                    }
                });
                if (lazyloadImages.length == 0) {
                    document.removeEventListener("scroll", lazyload);
                    window.removeEventListener("resize", lazyload);
                    window.removeEventListener("orientationChange", lazyload);
                }
            }, 20);
        }

        document.addEventListener("scroll", lazyload);
        window.addEventListener("resize", lazyload);
        window.addEventListener("orientationChange", lazyload);
    }
});

$(window).on('scroll', function () {
    if ($(this).scrollTop() > 55) {
        $('header').addClass('scrolled');
    } else {
        $('header').removeClass('scrolled');
    }
});